export default {
  choose: {
    title: 'Elimină pe {{name}} din rolul de proprietar',
    title_no_owner: 'Alege un proprietar pentru {{restaurant}}',
    description: 'Alege cine preia locul lui {{name}} sau lasă deocamdată {{restaurant}} fără proprietar.',
    description_no_owner: '{{restaurant}} nu are proprietar. Alege pe cineva din echipă sau o persoană nouă.',
    new_owner: 'Proprietar nou',
    previous_owner: '{{name}} după modificare',
  },
  options: {
    team: {
      title: 'Cineva din echipă',
      loading: 'Se încarcă echipa…',
      description_one: 'Orice Operator sau Angajat, {{count}} persoană.',
      description_few: 'Orice Operator sau Angajat, {{count}} persoane.',
      description_other: 'Orice Operator sau Angajat, {{count}} de persoane.',
      empty: 'Nu mai este nimeni în echipă deocamdată.',
      search: 'Caută în echipă după nume sau e-mail',
      no_match: 'Nimeni din echipă nu se potrivește cu „{{query}}”.',
    },
    new: {
      title: 'Cineva nou',
      description: 'Devine proprietar imediat și primește datele de autentificare prin e-mail.',
    },
    none: {
      title: 'Fără proprietar deocamdată',
      description: 'Alege un proprietar mai târziu. Până atunci, {{restaurant}} nu are proprietar.',
    },
    keep: {
      title: 'Rămâne în echipă ca Operator',
      description: 'Păstrează accesul la restaurantele pe care le gestionează acum.',
    },
    remove: {
      title: 'Eliminat din echipă',
      description: 'Pierde imediat accesul la panou.',
    },
  },
  roles: {
    operator: 'Operator',
    employee: 'Angajat',
  },
  fields: {
    first_name: 'Prenume',
    last_name: 'Nume',
    email: 'E-mail',
  },
  email_errors: {
    invalid_email: 'Introdu un e-mail valid, de exemplu nume@exemplu.com.',
    email_is_owner: '{{name}} este deja proprietar.',
    email_is_manager: '{{name}} face deja parte din echipă.',
    email_taken: 'O persoană din afara acestei echipe se autentifică deja cu acest e-mail. Folosește alt e-mail.',
  },
  confirm: {
    title: 'Elimini pe {{name}} din rolul de proprietar?',
    title_no_owner: 'Îl faci pe {{name}} proprietar?',
    description_both: 'Ambele modificări se fac împreună. Dacă una eșuează, nu se schimbă nimic.',
    description: 'Verifică modificarea înainte de a confirma.',
  },
  summary: {
    none: '<b>{{restaurant}}</b> nu are proprietar până nu alegi unul. Tot ce necesită proprietarul așteaptă până atunci.',
    new: '<b>{{name}}</b> devine imediat proprietarul restaurantului {{restaurant}}.',
    email:
      'Datele de autentificare ajung la <b>{{email}}</b>. Verifică adresa: oricine o are se poate autentifica drept proprietar.',
    team: '<b>{{name}}</b> devine proprietarul restaurantului {{restaurant}}.',
    group_access:
      'Ca proprietar, are acces la toate restaurantele din {{group}}, adică posibil la mai multe decât acum.',
    keep: '<b>{{name}}</b> rămâne în echipă ca Operator.',
    remove: '<b>{{name}}</b> este eliminat din echipă și nu se mai poate autentifica.',
  },
  error: {
    title: 'Nu am putut schimba proprietarul.',
    description: 'Nu s-a modificat nimic. Încearcă din nou sau contactează asistența dacă eroarea persistă.',
  },
  buttons: {
    close: 'Închide',
    continue: 'Continuă',
    cancel: 'Anulează',
    back: 'Înapoi',
    remove_as_owner: 'Elimină din rolul de proprietar',
    make_owner: 'Fă proprietar',
    saving: 'Se salvează…',
    try_again: 'Încearcă din nou',
    choose_instead: 'Alege-l pe {{name}}',
    invite_instead: 'Invită o persoană nouă',
  },
};
